exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3XI5pzA82_-QsaT-r45NDs{padding-left:1.42857rem}", ""]);

// exports
exports.locals = {
	"NormalTd": "_3XI5pzA82_-QsaT-r45NDs"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/TableView/Tds/NormalTd/style.postcss
// module id = 1262
// module chunks = 0